export default {
  isUpgrade: false,
  upgrade: false, // 更新弹窗是否显示
  upgradeData: {
    currentVersionName: '',
    versionName: '',
    packageSize: '',
    upgradeContent: []
  }
}
